(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2258],{

/***/ 32258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ LoginDialog; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js + 2 modules
var Dialog = __webpack_require__(93579);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(87066);
// EXTERNAL MODULE: ./node_modules/@amplitude/analytics-browser/lib/esm/index.js + 159 modules
var esm = __webpack_require__(65972);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./lib/firebase.ts + 2 modules
var firebase = __webpack_require__(83853);
// EXTERNAL MODULE: ./node_modules/firebase/auth/dist/esm/index.esm.js + 3 modules
var index_esm = __webpack_require__(69323);
// EXTERNAL MODULE: ./components/common/Icon/index.tsx
var Icon = __webpack_require__(37975);
// EXTERNAL MODULE: ./store/global.ts
var global = __webpack_require__(8405);
// EXTERNAL MODULE: ./components/common/LoginDialog/LoginDialog.module.scss
var LoginDialog_module = __webpack_require__(90517);
var LoginDialog_module_default = /*#__PURE__*/__webpack_require__.n(LoginDialog_module);
// EXTERNAL MODULE: ./common/utils/debounce.ts
var debounce = __webpack_require__(80582);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./common/utils/index.ts + 1 modules
var utils = __webpack_require__(22467);
// EXTERNAL MODULE: ./components/common/LoginDialog/ForgotPassDialog/ForgotPass.module.scss
var ForgotPass_module = __webpack_require__(1973);
var ForgotPass_module_default = /*#__PURE__*/__webpack_require__.n(ForgotPass_module);
// EXTERNAL MODULE: ./components/common/Button/index.tsx
var Button = __webpack_require__(98133);
;// CONCATENATED MODULE: ./components/common/LoginDialog/ForgotPassDialog/index.tsx












function ForgotPassDialog(param) {
    var open = param.open, handleClose = param.handleClose;
    var ref = (0,react.useState)(""), email = ref[0], setEmail = ref[1];
    var ref1 = (0,react.useState)(email ? "" : "メールを入力してください"), emailError = ref1[0], setEmailError = ref1[1];
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var handleEmailChange = function(e) {
        var email = e.target.value;
        setEmail(email);
        if (!email) {
            setEmailError("メールを入力してください");
        } else if (!(0,utils/* validEmail */.u$)(e.target.value)) {
            setEmailError("正しいメールアドレスを入力してください");
        } else if (emailError) {
            setEmailError("");
        }
    };
    var ref2 = (0,es.useMutation)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(email) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", axios/* default.post */.Z.post("/users/reset-password", {
                            email: email
                        }));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(email) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSuccess: function() {
            setSnackbarMessage({
                type: "success",
                text: "パスワードリセットを申請しました。メールを確認してください。"
            });
            handleClose();
        },
        onError: function() {
            setSnackbarMessage({
                type: "error",
                text: "エラーが発生しました。"
            });
        }
    }), isLoading = ref2.isLoading, sendMail = ref2.mutate;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        open: open,
        onClose: function() {
            handleClose();
        },
        maxWidth: "lg",
        PaperProps: {
            style: {
                backgroundColor: "transparent",
                boxShadow: "none",
                overflow: "hidden"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ForgotPass_module_default()).forgotPassDialogWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ForgotPass_module_default()).header,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "パスワードの再設定"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ForgotPass_module_default()).close,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                name: "close-black",
                                width: 14,
                                height: 14,
                                onClick: function() {
                                    return handleClose();
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ForgotPass_module_default()).infoGroup,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ForgotPass_module_default()).label,
                            children: "メールアドレス"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ForgotPass_module_default()).value,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: (ForgotPass_module_default()).input,
                                value: email,
                                type: "email",
                                onChange: handleEmailChange
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ForgotPass_module_default()).error,
                            children: emailError
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ForgotPass_module_default()).buttonWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        text: "送信する",
                        onClick: function() {
                            return sendMail(email);
                        },
                        isLoading: isLoading,
                        disabled: !!emailError
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/cookie/index.js
var node_modules_cookie = __webpack_require__(76489);
// EXTERNAL MODULE: ./common/utils/trackingTag.ts
var trackingTag = __webpack_require__(15769);
// EXTERNAL MODULE: ./common/utils/user.ts
var user = __webpack_require__(97542);
;// CONCATENATED MODULE: ./components/common/LoginDialog/index.tsx























var Mode;
(function(Mode) {
    Mode[Mode["INITIAL"] = 0] = "INITIAL";
    Mode[Mode["LOGIN"] = 1] = "LOGIN";
    Mode[Mode["REGISTER"] = 2] = "REGISTER";
})(Mode || (Mode = {}));
var validName = function(name) {
    return name && name.trim().length <= 15;
};
function LoginDialog() {
    var showLoginInput = (0,global/* default */.Z)(function(state) {
        return state.showLoginInput;
    });
    var showLogin = (0,global/* default */.Z)(function(state) {
        return state.showLogin;
    });
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var ref = (0,react.useState)((showLoginInput === null || showLoginInput === void 0 ? void 0 : showLoginInput.showingTitle) || "login"), showingTitle = ref[0], setShowingTitle = ref[1];
    var router = (0,next_router.useRouter)();
    var firebaseUser = (0,global/* default */.Z)(function(state) {
        return state.firebaseUser;
    });
    var ref1 = (0,react.useState)(false), processing = ref1[0], setProcessing = ref1[1];
    var ref2 = (0,react.useState)(Mode.INITIAL), mode = ref2[0], setMode = ref2[1];
    var ref3 = (0,react.useState)(""), email = ref3[0], setEmail = ref3[1];
    var ref4 = (0,react.useState)(""), password = ref4[0], setPassword = ref4[1];
    var ref5 = (0,react.useState)(""), passwordConfirm = ref5[0], setPasswordConfirm = ref5[1];
    var ref6 = (0,react.useState)(""), name = ref6[0], setName = ref6[1];
    var ref7 = (0,react.useState)(false), openForgotPass = ref7[0], setOpenForgotPass = ref7[1];
    var ref8 = (0,react.useState)(), newAccountParam = ref8[0], setNewAccountParam = ref8[1];
    // const nameRef = useRef<string>();
    var ref9 = (0,react.useState)(false), hasUserAction = ref9[0], setHasUserAction = ref9[1];
    // Error
    var ref10 = (0,react.useState)(""), emailError = ref10[0], setEmailError = ref10[1];
    var ref11 = (0,react.useState)(""), passwordError = ref11[0], setPasswordError = ref11[1];
    var ref12 = (0,react.useState)(""), passwordConfirmError = ref12[0], setPasswordConfirmError = ref12[1];
    var ref13 = (0,react.useState)(""), nameError = ref13[0], setNameError = ref13[1];
    var ref14 = (0,react.useState)(false), isInputValid = ref14[0], setInputValid = ref14[1];
    (0,react.useEffect)(function() {
        if (showLoginInput) {
            setShowingTitle((showLoginInput === null || showLoginInput === void 0 ? void 0 : showLoginInput.showingTitle) || "login");
        }
    }, [
        showLoginInput
    ]);
    // Only run once.
    (0,react.useEffect)(function() {
        if (!showLoginInput) return;
        try {
            (0,user/* openLoginDialogEvent */.F$)(router.pathname);
            (0,esm/* track */.j)("Show Login Popup");
        // eslint-disable-next-line no-empty
        } catch (e) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showLoginInput
    ]);
    // Validate email
    (0,react.useEffect)(function() {
        if (mode !== Mode.INITIAL && email && !(0,utils/* validEmail */.u$)(email)) {
            setEmailError("無効のメールアドレス");
        } else {
            setEmailError("");
        }
    }, [
        mode,
        email
    ]);
    // Validate password
    (0,react.useEffect)(function() {
        if (password && !(0,utils/* validPassword */.hE)(password)) {
            if (mode === Mode.REGISTER) {
                setPasswordError("8文字以上の半角英数字で入力してください");
            }
        } else {
            setPasswordError("");
        }
    }, [
        password,
        mode
    ]);
    // Validate confirm password
    (0,react.useEffect)(function() {
        if (password && !(0,utils/* validPasswordConfirm */.bA)(password, passwordConfirm)) {
            setPasswordConfirmError("パスワードが一致しません");
        } else {
            setPasswordConfirmError("");
        }
    }, [
        password,
        passwordConfirm
    ]);
    // Validate name
    (0,react.useEffect)(function() {
        if (name && !validName(name)) {
            setNameError("15文字以内で入力してください");
        } else {
            setNameError("");
        }
    }, [
        name
    ]);
    (0,react.useEffect)(function() {
        if (mode === Mode.INITIAL && !(0,utils/* validEmail */.u$)(email)) {
            setInputValid(false);
        } else if (mode === Mode.LOGIN && (!email || emailError || !password || passwordError)) {
            setInputValid(false);
        } else if (mode === Mode.REGISTER && (!email || emailError || !name || nameError || !password || passwordError || !passwordConfirm || passwordConfirmError)) {
            setInputValid(false);
        } else {
            setInputValid(true);
        }
    }, [
        mode,
        email,
        emailError,
        password,
        passwordError,
        name,
        nameError,
        passwordConfirm,
        passwordConfirmError, 
    ]);
    var handleClose = function() {
        showLogin(null);
    };
    // reset all fields when closed
    (0,react.useEffect)(function() {
        // delay fields reset a bit so that it happens after the dialog is fully closed
        if (showLoginInput) return;
        var timeout = setTimeout(function() {
            setEmail("");
            setPassword("");
            setName("");
            setMode(Mode.INITIAL);
        }, 200);
        return function() {
            return timeout && clearTimeout(timeout);
        };
    }, [
        showLoginInput
    ]);
    var ref15 = (0,es.useMutation)(function(email) {
        return (0,index_esm/* fetchSignInMethodsForEmail */.Nr)(firebase/* firebaseAuth */.l, email);
    }, {
        onSuccess: function(res) {
            if (res.length === 0) {
                setMode(Mode.REGISTER);
            } else {
                // res is a array of login provider. example: ['password', 'google.com']
                if (!res.includes("password")) {
                    var platform = providerName(res[0]);
                    setEmailError("既に".concat(platform, "アカウントで利用中です。</br>").concat(platform, "で続けるからログインください。"));
                } else {
                    setMode(Mode.LOGIN);
                }
            }
        },
        onError: function(error) {
            if (error.code === "auth/invalid-email") {
                setEmailError("無効のメールアドレス");
            } else {
                setEmailError("エラーが発生しました");
            }
        }
    }), isCheckingEmail = ref15.isLoading, checkEmail = ref15.mutate;
    var ref16 = (0,es.useMutation)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var avatar, name, email, cookie, trackingParam, _query, utm_source, utm_medium, utm_campaign, source, campaign, medium;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        avatar = param.avatar, name = param.name, email = param.email;
                        cookie = (0,node_modules_cookie/* parse */.Q)(document === null || document === void 0 ? void 0 : document.cookie);
                        trackingParam = (0,trackingTag/* generateTrackingParam */.as)(cookie);
                        _query = router.query, utm_source = _query.utm_source, utm_medium = _query.utm_medium, utm_campaign = _query.utm_campaign;
                        source = utm_source || trackingParam.utm_source || "";
                        campaign = utm_campaign || trackingParam.utm_campaign || "";
                        medium = utm_medium || trackingParam.utm_medium || "";
                        _ctx.next = 9;
                        return axios/* default.post */.Z.post("/users/", (0,_object_spread/* default */.Z)({
                            avatar: avatar,
                            name: name || "PostPrime User",
                            email: email
                        }, (utm_source || utm_medium || utm_campaign || trackingParam.utm_source) && {
                            source: {
                                utm_source: source,
                                utm_medium: medium,
                                utm_campaign: campaign
                            }
                        }));
                    case 9:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSuccess: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return firebaseUser.getIdToken(true);
                    case 2:
                        (0,user/* createAccountEvent */.fr)(router.pathname);
                        (0,esm/* track */.j)("Complete Registration");
                        setSnackbarMessage({
                            text: "新規アカウントが作成されました",
                            type: "success"
                        });
                        setTimeout(function() {
                            void firebaseUser.getIdToken(true);
                        }, 1000);
                        setTimeout(function() {
                            void firebaseUser.getIdToken(true);
                        }, 2000);
                        if (router.pathname === "/lp") {
                            void router.push("/");
                        }
                        setProcessing(false);
                        showLogin(null);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        onError: function() {
            setSnackbarMessage({
                text: "エラーが発生しました",
                type: "error"
            });
        }
    }), createPostPrimeAccount = ref16.mutate;
    var debouncedCheckEmail = (0,react.useMemo)(function() {
        return (0,debounce/* default */.Z)(checkEmail, 500);
    }, [
        checkEmail
    ]);
    (0,react.useEffect)(function() {
        if (firebaseUser) {
            var ref;
            var createUser = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                    var name, email, avatar, idTokenResult, claims, isNewUser;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                name = param.name, email = param.email, avatar = param.avatar;
                                _ctx.next = 3;
                                return (0,index_esm/* getIdTokenResult */.ag)(firebaseUser);
                            case 3:
                                idTokenResult = _ctx.sent;
                                claims = idTokenResult.claims;
                                isNewUser = !claims.yp_user_id;
                                if (!isNewUser) {
                                    _ctx.next = 21;
                                    break;
                                }
                                _ctx.prev = 7;
                                if (!(firebaseUser.providerData[0].providerId === "password" && !name)) {
                                    _ctx.next = 10;
                                    break;
                                }
                                return _ctx.abrupt("return");
                            case 10:
                                setNewAccountParam({
                                    uid: firebaseUser.uid,
                                    email: email,
                                    name: name,
                                    avatar: avatar
                                });
                                _ctx.next = 19;
                                break;
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](7);
                                console.error("Error creating user!");
                                setSnackbarMessage({
                                    type: "error",
                                    text: "新規ユーザー作成が失敗しました",
                                    autoHideDuration: 6000
                                });
                                checkEmail(email);
                                if (axios/* default.isAxiosError */.Z.isAxiosError(_ctx.t0)) {
                                    if (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.response) {
                                        console.error(_ctx.t0.response.data);
                                    } else {
                                        console.error(_ctx.t0);
                                    }
                                }
                            case 19:
                                _ctx.next = 22;
                                break;
                            case 21:
                                {
                                    showLogin(null);
                                }
                            case 22:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            7,
                            13
                        ]
                    ]);
                }));
                return function createUser(_) {
                    return _ref.apply(this, arguments);
                };
            }();
            void createUser({
                email: firebaseUser.email,
                name: name || ((ref = firebaseUser.displayName) === null || ref === void 0 ? void 0 : ref.slice(0, 15)),
                avatar: firebaseUser.photoURL
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        firebaseUser
    ]);
    (0,react.useEffect)(function() {
        if ((newAccountParam === null || newAccountParam === void 0 ? void 0 : newAccountParam.uid) && hasUserAction) {
            createPostPrimeAccount({
                name: newAccountParam.name,
                avatar: newAccountParam.avatar,
                email: newAccountParam.email
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        newAccountParam === null || newAccountParam === void 0 ? void 0 : newAccountParam.uid
    ]);
    var facebookProvider = new index_esm/* FacebookAuthProvider */._O();
    var googleProvider = new index_esm/* GoogleAuthProvider */.hJ();
    var appleProvider = new index_esm/* OAuthProvider */.O4("apple.com");
    // const twitterProvider = new TwitterAuthProvider();
    var handleAuthError = function(e, errorText) {
        console.error(e);
        if ((e === null || e === void 0 ? void 0 : e.code) === "auth/account-exists-with-different-credential") {
            errorText = "既に他のソーシャルアカウントで".concat((e === null || e === void 0 ? void 0 : e.email) ? "「".concat(e === null || e === void 0 ? void 0 : e.email, "」") : "該当メールアドレス", "を利用してログインしました。このメールアドレスに関連付けられているプロバイダーを使用してサインインしてください。");
        }
        setSnackbarMessage({
            type: "error",
            text: errorText,
            autoHideDuration: 6000
        });
    };
    var handleEmailLogin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setProcessing(true);
                        setHasUserAction(true);
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return (0,index_esm/* signInWithEmailAndPassword */.e5)(firebase/* firebaseAuth */.l, email, password);
                    case 5:
                        if (router.pathname === "/lp") {
                            void router.push("/");
                        }
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](2);
                        handleAuthError(_ctx.t0, "ログインに失敗しました");
                    case 11:
                        _ctx.prev = 11;
                        setProcessing(false);
                        return _ctx.finish(11);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    8,
                    11,
                    14
                ]
            ]);
        }));
        return function handleEmailLogin() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleEmailRegister = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setProcessing(true);
                        setHasUserAction(true);
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return (0,index_esm/* createUserWithEmailAndPassword */.Xb)(firebase/* firebaseAuth */.l, email, password);
                    case 5:
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](2);
                        handleAuthError(_ctx.t0, "アカウント登録に失敗しました");
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    7
                ]
            ]);
        }));
        return function handleEmailRegister() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleLoginWithProvider = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(provider) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setHasUserAction(true);
                        _ctx.next = 4;
                        return (0,index_esm/* signInWithPopup */.rh)(firebase/* firebaseAuth */.l, provider);
                    case 4:
                        if (router.pathname === "/lp") {
                            void router.push("/");
                        }
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        handleAuthError(_ctx.t0, "ログインに失敗しました");
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function handleLoginWithProvider(provider) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleFacebookLogin = function() {
        void handleLoginWithProvider(facebookProvider);
    };
    var handleGoogleLogin = function() {
        googleProvider.setCustomParameters({
            prompt: "select_account"
        });
        void handleLoginWithProvider(googleProvider);
    };
    var handleAppleLogin = function() {
        void handleLoginWithProvider(appleProvider);
    };
    // const handleTwitterLogin = () => {
    //   void handleLoginWithProvider(twitterProvider);
    // };
    var handlePasswordKeydown = function(e) {
        if (e.key === "Enter") {
            void handleEmailLogin();
        }
    };
    var handleEmailChange = function(e) {
        setEmail(e.target.value);
        if (mode !== Mode.INITIAL) {
            debouncedCheckEmail(e.target.value);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        open: !!showLoginInput,
        onClose: handleClose,
        scroll: "body",
        PaperProps: {
            style: {
                backgroundColor: "transparent",
                boxShadow: "none"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: (LoginDialog_module_default()).dialogWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (LoginDialog_module_default()).closeBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "close",
                            width: 28,
                            height: 28,
                            onClick: handleClose
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (LoginDialog_module_default()).tabList,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((LoginDialog_module_default()).tab, (0,_define_property/* default */.Z)({}, (LoginDialog_module_default()).selected, showingTitle === "login" && mode === Mode.INITIAL || mode === Mode.LOGIN)),
                                onClick: function() {
                                    return setShowingTitle("login");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (LoginDialog_module_default()).tabContent,
                                    children: "ログイン"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((LoginDialog_module_default()).tab, (0,_define_property/* default */.Z)({}, (LoginDialog_module_default()).selected, showingTitle === "signup" && mode === Mode.INITIAL || mode === Mode.REGISTER)),
                                onClick: function() {
                                    return setShowingTitle("signup");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (LoginDialog_module_default()).tabContent,
                                    children: "新規作成"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((LoginDialog_module_default()).loginBtn, (LoginDialog_module_default()).apple),
                        onClick: handleAppleLogin,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LoginDialog_module_default()).logo,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                    name: "apple-black",
                                    width: 20,
                                    height: 24
                                })
                            }),
                            "Appleで続ける"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((LoginDialog_module_default()).loginBtn, (LoginDialog_module_default()).facebook),
                        onClick: handleFacebookLogin,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LoginDialog_module_default()).logo,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                    name: "facebook-blue",
                                    width: 14,
                                    height: 26
                                })
                            }),
                            "Facebookで続ける"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((LoginDialog_module_default()).loginBtn, (LoginDialog_module_default()).google),
                        onClick: handleGoogleLogin,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LoginDialog_module_default()).logo,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                    name: "google",
                                    width: 44,
                                    height: 44
                                })
                            }),
                            "Googleで続ける"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (LoginDialog_module_default()).dividerGroup,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LoginDialog_module_default()).divider
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LoginDialog_module_default()).dividerText,
                                children: "または"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (LoginDialog_module_default()).inputGroup,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: (LoginDialog_module_default()).label,
                                htmlFor: "email-login-email",
                                children: "メールアドレス"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (LoginDialog_module_default()).emailWrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "email",
                                        id: "email-login-email",
                                        name: "email-login-email",
                                        placeholder: "（例）tarosuzuki@gmail.com",
                                        value: email,
                                        onChange: handleEmailChange,
                                        autoComplete: "email",
                                        disabled: processing
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (LoginDialog_module_default()).checking,
                                        children: isCheckingEmail && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                            name: "loading-anim-3",
                                            width: 24,
                                            height: 24
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LoginDialog_module_default()).error,
                                dangerouslySetInnerHTML: {
                                    __html: emailError
                                }
                            })
                        ]
                    }),
                    mode === Mode.INITIAL && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: classnames_default()((LoginDialog_module_default()).loginBtn, (LoginDialog_module_default()).normal),
                        onClick: function(e) {
                            e.preventDefault();
                            checkEmail(email);
                        },
                        disabled: !isInputValid || processing,
                        children: processing ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "loading-anim-2",
                            width: 24,
                            height: 24
                        }) : "メールアドレスで続ける"
                    }),
                    mode === Mode.LOGIN && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (LoginDialog_module_default()).inputGroup,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: (LoginDialog_module_default()).label,
                                        htmlFor: "email-login-password",
                                        children: "パスワード"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "password",
                                        id: "email-login-password",
                                        name: "email-login-password",
                                        autoComplete: "current-password",
                                        value: password,
                                        onChange: function(e) {
                                            return setPassword(e.target.value);
                                        },
                                        onKeyDown: handlePasswordKeydown,
                                        disabled: processing
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (LoginDialog_module_default()).error,
                                        children: passwordError
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: classnames_default()((LoginDialog_module_default()).loginBtn, (LoginDialog_module_default()).normal),
                                onClick: handleEmailLogin,
                                type: "button",
                                disabled: !isInputValid || processing,
                                children: processing ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                    name: "loading-anim-2",
                                    width: 24,
                                    height: 24
                                }) : "ログイン"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: (LoginDialog_module_default()).forgetPass,
                                onClick: function() {
                                    return setOpenForgotPass(true);
                                },
                                children: "パスワードを忘れた方"
                            }),
                            openForgotPass && /*#__PURE__*/ (0,jsx_runtime.jsx)(ForgotPassDialog, {
                                open: openForgotPass,
                                handleClose: function() {
                                    return setOpenForgotPass(false);
                                }
                            })
                        ]
                    }),
                    mode === Mode.REGISTER && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (LoginDialog_module_default()).inputGroup,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: (LoginDialog_module_default()).label,
                                        htmlFor: "email-register-name",
                                        children: "名前"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "text",
                                        id: "email-register-name",
                                        name: "email-register-name",
                                        autoComplete: "current-name",
                                        value: name,
                                        onChange: function(e) {
                                            return setName(e.target.value);
                                        },
                                        placeholder: "例）高橋ダン",
                                        disabled: processing
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (LoginDialog_module_default()).error,
                                        children: nameError
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (LoginDialog_module_default()).inputGroup,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: (LoginDialog_module_default()).label,
                                        htmlFor: "email-register-password",
                                        children: "パスワード"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "password",
                                        id: "email-register-password",
                                        name: "email-register-password",
                                        autoComplete: "new-password",
                                        value: password,
                                        onChange: function(e) {
                                            return setPassword(e.target.value);
                                        },
                                        disabled: processing
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (LoginDialog_module_default()).error,
                                        children: passwordError
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (LoginDialog_module_default()).inputGroup,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: (LoginDialog_module_default()).label,
                                        htmlFor: "email-register-password-confirm",
                                        children: "確認用のパスワード"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "password",
                                        id: "email-register-password-confirm",
                                        name: "email-register-password-confirm",
                                        autoComplete: "new-password",
                                        value: passwordConfirm,
                                        onChange: function(e) {
                                            return setPasswordConfirm(e.target.value);
                                        },
                                        disabled: processing
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (LoginDialog_module_default()).error,
                                        children: passwordConfirmError
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: classnames_default()((LoginDialog_module_default()).loginBtn, (LoginDialog_module_default()).normal),
                                onClick: handleEmailRegister,
                                type: "button",
                                disabled: !isInputValid || processing,
                                children: processing ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                    name: "loading-anim-2",
                                    width: 24,
                                    height: 24
                                }) : "アカウント作成してホームへ"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (LoginDialog_module_default()).policy,
                                children: [
                                    "アカウントを作成することで、",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: utils/* USER_TERM_URL */.Du,
                                        target: "_blank",
                                        children: "利用規約"
                                    }),
                                    "と",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: utils/* POLICY_URL */.Jk,
                                        target: "_blank",
                                        children: "プライバシーポリシー"
                                    }),
                                    "に",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "同意するものとします。"
                                ]
                            })
                        ]
                    })
                ]
            }),
            (newAccountParam === null || newAccountParam === void 0 ? void 0 : newAccountParam.uid) && hasUserAction && /*#__PURE__*/ (0,jsx_runtime.jsx)(AtssNewAccountImageTag, {
                uid: newAccountParam === null || newAccountParam === void 0 ? void 0 : newAccountParam.uid
            })
        ]
    });
};
var providerName = function(provider) {
    switch(provider){
        case "google.com":
            return "Google";
        case "facebook.com":
            return "Facebook";
        case "twitter.com":
            return "Twitter";
        case "apple.com":
            return "Apple";
        default:
            return "他のソーシャル";
    }
};
var AtssNewAccountImageTag = function(param) {
    var uid = param.uid;
    var ref = (0,react.useState)(""), rkParam = ref[0], setRkParam = ref[1];
    var ref1 = (0,react.useState)(""), verify = ref1[0], setVerify = ref1[1];
    (0,react.useEffect)(function() {
        var cookie = (0,node_modules_cookie/* parse */.Q)(document === null || document === void 0 ? void 0 : document.cookie);
        if (cookie.atss_js) {
            setRkParam(cookie.atss_js);
        }
        if (cookie.atss_verify) {
            setVerify(cookie.atss_verify);
        }
    }, []);
    if (!(0,utils/* isProduction */.MF)()) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (!uid || !rkParam || !verify) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: "https://is.accesstrade.net/cgi-bin/isatV2/postprime/isatWeaselV2.cgi?result_id=103&verify=".concat(verify, "&rk=").concat(rkParam),
        width: 1,
        height: 1
    });
};


/***/ }),

/***/ 1973:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"forgotPassDialogWrapper":"ForgotPass_forgotPassDialogWrapper__ro8mu","header":"ForgotPass_header__woarn","close":"ForgotPass_close__K8KOo","infoGroup":"ForgotPass_infoGroup___rEL2","label":"ForgotPass_label__s4j1F","value":"ForgotPass_value__eH6Dt","input":"ForgotPass_input__9Gf5z","error":"ForgotPass_error__F0MXP","buttonWrapper":"ForgotPass_buttonWrapper__gsHlJ"};

/***/ }),

/***/ 90517:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dialogWrapper":"LoginDialog_dialogWrapper__owPzX","closeBtn":"LoginDialog_closeBtn__opUd2","tabList":"LoginDialog_tabList__bPypZ","tab":"LoginDialog_tab__JqH1n","tabContent":"LoginDialog_tabContent__nEYko","selected":"LoginDialog_selected__6lnNI","dividerGroup":"LoginDialog_dividerGroup__yePlN","divider":"LoginDialog_divider___Fj0B","dividerText":"LoginDialog_dividerText__Gg25g","teenCheckWrapper":"LoginDialog_teenCheckWrapper__Msge8","teenCheckTitle":"LoginDialog_teenCheckTitle__5shta","teenCheckGroup":"LoginDialog_teenCheckGroup__pUE1B","teenCheckRadioBtn":"LoginDialog_teenCheckRadioBtn__0_JoX","teenAgeSelect":"LoginDialog_teenAgeSelect__mgwkr","checkboxWrapper":"LoginDialog_checkboxWrapper__j1bbX","settingCheckbox":"LoginDialog_settingCheckbox___JfPW","inputGroup":"LoginDialog_inputGroup__omncb","emailWrapper":"LoginDialog_emailWrapper__MPd2_","checking":"LoginDialog_checking__uyYkb","label":"LoginDialog_label__5nEOl","error":"LoginDialog_error__Mye9o","loginBtn":"LoginDialog_loginBtn__u97Bo","logo":"LoginDialog_logo__Rx1qL","normal":"LoginDialog_normal__VHlec","facebook":"LoginDialog_facebook__4sapi","apple":"LoginDialog_apple__hD4hg","twitter":"LoginDialog_twitter__FbX2f","forgetPass":"LoginDialog_forgetPass__r45zM","policy":"LoginDialog_policy__T4cUZ"};

/***/ })

}]);